// A bizonylat FAJTÁJÁNAK jelvénye (user-döntés): a típus és a kézbesítés EGY jelvényben — „e-számla" (boríték),
// „számla" (papír alapú, papír-ikon), „díjbekérő" (mindig papír alapú, papír-ikon), a sztornózott számla „sztornó"
// (piros, áthúzás). A fajtát a KÖZÖS szabály adja (`@atlas/shared` `invoiceDocKind`), amivel a számlák listájának
// típus-szűrője is szűr — a jelvény és a szűrő nem térhet el. A jel a badge-katalógusból (`invoiceDoc`).
import { invoiceDocKind } from '@atlas/shared';
import { type TFunction } from 'i18next';

import { DomainBadge } from '@/components/shared/domain-badge';

export interface InvoiceTypeBadgeProps {
  /** A nyers bizonylat-típus (`invoice` | `proforma`). */
  type: string | null | undefined;
  /** A kézbesítés (`electronic` | `paper`); hiányzó → elektronikus. */
  deliveryType: string | null | undefined;
  /** A bizonylat státusza — a sztornózott számla „sztornó"-ként jelenik meg. Hiányzó → nem sztornó. */
  status?: string | null | undefined;
  t: TFunction;
  className?: string;
}

export function InvoiceTypeBadge({
  type,
  deliveryType,
  status,
  t,
  className,
}: InvoiceTypeBadgeProps): JSX.Element {
  const kind = invoiceDocKind({ type, deliveryType, status });
  return (
    <DomainBadge
      kind="invoiceDoc"
      value={kind}
      label={t(`invoices.docKind.${kind}`)}
      className={className}
    />
  );
}
